import React, { useEffect, useState } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { useSelector } from 'react-redux'
import { getCourseLandingPageAction } from 'src/reducers/course/action'
import { useDispatch } from 'react-redux'
import { GeneralSettings, SeoSettings, AdvancedSettings } from './components'
import { Icon } from '@iconify/react'

const LandingPageSettings = props => {
  const { classes, onSave } = props
  const [isLoading, setIsLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('general')
  const course = useSelector(state => state.course.course)
  const landingPageCourse = useSelector(
    state => state.course.landingPageSettings,
  )

  const { collection } = useSelector(state => state)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  const pageUrl = window.location.pathname.split('/')[1]
  const landingPageSettings =
    pageUrl === 'mini-course' ? landingPageCourse : collectionSettings

  const dispatch = useDispatch()

  // Create a state object to store all settings
  const [settings, setSettings] = useState(null)

  // Initialize settings from Redux when component mounts
  useEffect(() => {
    if (landingPageSettings) {
      setSettings(landingPageSettings)
      onSave(landingPageSettings)
    }
  }, [landingPageSettings, onSave])

  // Update settings and call onSave when settings change
  const updateSettings = newValues => {
    const updatedSettings = { ...settings, ...newValues }
    setSettings(updatedSettings)
    onSave(updatedSettings)
  }

  const tabList = [
    {
      label: 'General',
      path: 'general',
      icon: 'solar:settings-outline',
    },
    {
      label: 'SEO',
      path: 'seo',
      icon: 'solar:card-search-outline',
    },
    {
      label: 'Advanced',
      path: 'advanced',
      icon: 'proicons:apps-add',
    },
  ]

  const renderContent = () => {
    switch (activeTab) {
      case 'general':
        return (
          <GeneralSettings
            onSave={updateSettings}
            key="GeneralSettings"
            initialSettings={settings}
          />
        )
      case 'seo':
        return (
          <SeoSettings onSave={updateSettings} initialSettings={settings} />
        )
      case 'advanced':
        return (
          <AdvancedSettings
            onSave={updateSettings}
            initialSettings={settings}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.sidebar}>
          {tabList.map(item => (
            <div
              key={item.path}
              className={`${classes.leftSideListItem} ${
                activeTab === item.path ? classes.active : ''
              }`}
              onClick={() => setActiveTab(item.path)}
            >
              <Icon
                icon={item.icon}
                style={{
                  width: '18px',
                  height: '18px',
                }}
              />
              <Typography fontWeight={400}>{item.label}</Typography>
            </div>
          ))}
        </div>
        <div className={classes.mainContent}>{renderContent()}</div>
      </div>
    </div>
  )
}
export default withStyles(styles)(LandingPageSettings)
